import Vue from 'vue';
import Router from 'vue-router';
import { logout } from '@/module/service/oAuth';
import BSS from './bss';
import OSS from './oss';
import OMS from './oms';
import AMS from './ams';
import CMS from './cms';
// import DBM from './dbm';
import BMR from './bmr';
import { permission } from '../permission';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    permission['menu.bss'] && BSS,
    permission['menu.oss'] && OSS,
    permission['menu.oms'] && OMS,
    permission['menu.ams'] && AMS,
    permission['menu.cms'] && CMS,
    // permission['menu.dbm'] && DBM,
    permission['menu.bmr'] && BMR,
    {
      path: '/',
      redirect: '/business/dashboard'
    }
  ].filter((o) => o),
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (to.query) {
    const query = to.query;
    // Convert string 'true' to boolean true
    Object.keys(query).forEach((key) => {
      if (query[key] === 'true') {
        query[key] = true;
      }
    });
  }
  if (to.path === '/logout') {
    return logout();
  }
  // R&D / admin 受限路由的前端兜底守卫。
  // 注意：部门信息由 SSO 异步注入，未就绪时（departments 为空）放行，交由后端 403 兜底，
  // 避免页面刷新瞬间误把合法用户挡在外面。
  let requireRD = to.matched.some((r) => r.meta && r.meta.requireRD);
  let requireAdmin = to.matched.some((r) => r.meta && r.meta.requireAdmin);
  if (requireRD || requireAdmin) {
    // 延迟 require，规避 router 与 store 的模块加载顺序/循环依赖问题
    let store = require('../store').default;
    // 以部门名是否就绪作为判断依据：SSO 下发后才校验，未就绪时放行交由后端 403 兜底，
    // 避免页面刷新瞬间 SSO 数据未回误把合法用户挡在外面
    let departmentsLoaded = (store.state.oAuth.department_names || []).length > 0;
    if (departmentsLoaded) {
      if (requireRD && !store.getters['oAuth/isRD']) {
        return next(false);
      }
      if (requireAdmin && !store.getters['oAuth/isAdmin']) {
        return next(false);
      }
    }
  }
  next();
});

export default router;
